import { Membership, Tenant, User } from "@bluefalcon/users-management-client-fetch";
import { Box, Button, Flex, Input, Table, Tbody, Td, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { ConfirmModal } from "../../modals/confirm-modal.modal";
import { membershipService } from "../../services";
import { GrantMembershipModal } from "../../modals/grant-membership.modal";

type MembershipsTableProps = {
    memberships: Membership[];
    tenant?: Tenant;
    user?: User;
    onChange: () => void;
};

export const MembershipsTable = ({
    memberships,
    tenant,
    user,
}: MembershipsTableProps) => {
    const [dooomedMembership, setDoomedMembership] = useState<Membership>();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const grantControl = useDisclosure();
    const [query, setQuery] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const removeMembership = async () => {
        try {
            setIsLoading(true);
            if (dooomedMembership) {
                await membershipService.revokeMembership(dooomedMembership.id);
            }
        } finally {
            setIsLoading(false);
            setDoomedMembership(undefined);
            onClose();
        }
    };

    const handleRemoveButtonClick = (membership: Membership) => {
        setDoomedMembership(membership);
        onOpen();
    };

    const search = () => {

    };

    const grantMembership = async (tenantId: string, userId: string) => {
        try {
            setIsLoading(true);
            await membershipService.grantMembership(tenantId, userId);
        } finally {
            grantControl.onClose();
            setIsLoading(false);
        }
    };

    return (
        <Box>
            <Flex>
                <form onSubmit={search}>
                    <Flex>
                        <Input onChange={(e) => setQuery(e.target.value)} value={query} placeholder="search..." type={'search'} />
                        <Button type="submit" onClick={search} ml={2} colorScheme="primary">Search</Button>
                    </Flex>
                </form>
                <Button ml={'auto'} colorScheme="teal" onClick={grantControl.onOpen}>Grant Membership</Button>
            </Flex>
            {memberships.length > 0 ? <Table variant="simple">
                <Thead>
                    <Tr>
                        <Th>Id</Th>
                        <Th>Tenant</Th>
                        <Th>User</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {memberships.map((membership) => (
                        <Tr key={membership.id}>
                            <Td>{membership.id}</Td>
                            <Td>{membership.tenantId}</Td>
                            <Td>{`${membership.user?.firstName} ${membership.user?.lastName}`}</Td>
                            <Td>
                                <Button mr={2} size="sm" onClick={() => handleRemoveButtonClick(membership)}>
                                    Revoke
                                </Button>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table> : <Box textAlign={'center'} mt={5}>
                No memberships found.
            </Box>}
            {dooomedMembership && <ConfirmModal
                isOpen={isOpen}
                message={`Are you sure you want to revoke this membership?`}
                onCancel={onClose}
                onClose={onClose}
                onConfirm={removeMembership}
            />}
            <GrantMembershipModal
                isOpen={grantControl.isOpen}
                onClose={grantControl.onClose}
                onGrant={grantMembership}
                initialTenant={tenant}
                initialUser={user}
                isLoading={isLoading}
            />
        </Box>
    )
}